import React from 'react';
import Card from '../../Shared/Cards/FeatureCard/Card';
import { customers } from './data';
import './Styles/Customer.scss';

const Customer=()=>{
    return(
        <div className="customer-enterprise">
            <h1>A customer experience you’ll love</h1>
            <div className="cards">
                {customers.map((d) =>{
                    return(
                        <Card {...d} styles="noborder-feature"/>
                    )
                })}
            </div>
        </div>
    )
};
export default Customer ;